// /ote-print/:token — print-only page for the CCIS OTE verification report PDF (opened by the headless renderer,
// netlify/functions/render-ote-background.js). The MOM endorsement is NOT printed here — it is MOM's own Excel form,
// filled in by the renderer. Sets window.__READY__ once drawn; any image that fails to load fails the print (never a
// report silently missing a photo).
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import { OTEReport } from '../components/OTEDocuments'

export default function OTEPrint() {
  const { token } = useParams()
  const [data, setData] = useState(null)
  const [err, setErr] = useState('')

  useEffect(() => {
    supabase.rpc('get_ote_print', { p_token: token }).then(({ data, error }) => {
      if (error || !data) { setErr('Document not found.'); window.__OTE_ERROR__ = (error && error.message) || 'Document not found'; return }
      setData(data)
    })
  }, [token])

  useEffect(() => {
    if (!data) return
    const imgs = Array.from(document.images)
    Promise.all(imgs.map(i => i.complete ? (i.naturalWidth ? null : Promise.reject(i.src)) : new Promise((ok, bad) => { i.onload = ok; i.onerror = () => bad(i.src) })))
      .then(() => { window.__READY__ = true })
      .catch(() => { window.__OTE_ERROR__ = 'an image (photo, logo or signature) could not be loaded' })
  }, [data])

  if (err) return <div style={{ padding: 40 }}>{err}</div>
  if (!data) return null
  return (
    <div style={{ background: '#fff' }}>
      <style>{'@page { size: A4; } body { background: #fff !important; margin: 0; } * { -webkit-print-color-adjust: exact; print-color-adjust: exact; }'}</style>
      <OTEReport snapshot={data.snapshot} logos={data.logos} />
    </div>
  )
}
